<template>
  <section>
    <gs-header title="Sửa phiếu chi"
      :breadcrumbs="[
        {title: 'Quản lý phiếu chi', route: {name: 'invoice'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all margin-top">
      <el-form label-position="top" :rules="rules" ref="edit-invoice-form" :model="localInvoice" label-width="150px" @submit.prevent.native="validatorBeforeSubmit">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Tìm kiếm người nhận" prop="client_id" class="is-required">
              <el-select class="display-block"
                v-model="suggettionReceiver"
                filterable
                remote
                placeholder="Nhập tên, sđt..."
                :remote-method="selectReceiver"
                :loading="fetchReceiver"
                @change="selectSuggettionReceiver"
                >
                <el-option
                  v-for="item in listReceiver"
                  :key="item.id"
                  :value="item">
                  <span class="pull-left text-gray"><i class="fa fa-user"></i>&nbsp;{{ item.name }}</span>
                  <span class="pull-right text-violet"><i class="fa fa-phone"></i>&nbsp;{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Tìm kiếm vận đơn">
              <el-select class="display-block"
                v-model="suggettionShipment"
                filterable
                remote
                :disabled="!localInvoice.client_id"
                placeholder="Nhập mã,..."
                :remote-method="selectShipment"
                :loading="fetchShipment"
                @change="selectSuggettionShipment"
                >
                <el-option
                  v-for="item in listShipment"
                  :key="item.id"
                  :value="item">
                  <span class="pull-left shipment-code-display">{{ item.id }}</span>
                  <span class="pull-right shipment-code-display">{{ item.code }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Lý do" prop="description">
              <el-input type="textarea" :rows="4" v-model="localInvoice.description" placeholder="Lý do"></el-input>
            </el-form-item>
            <el-form-item label="Loại phiếu" prop="kind">
              <el-select class="display-block"
                v-model="localInvoice.kind"
                filterable
                placeholder="Loại phiếu"
                >
                <el-option
                  v-for="(item, key, index) in invoiceHelpers.kinds"
                  :key="index"
                  :value="key"
                  :label="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Tổng tiền phải trả cho shop" prop="total_amount">
              <el-input @focus="removeZero('total_amount')" @blur="addZero('total_amount')" v-model="localInvoice.total_amount" placeholder="Tổng tiền phải trả cho shop">
                <template slot="append"><span class="text-red">{{localInvoice.total_amount | vnd}}</span></template>
              </el-input>
            </el-form-item>
            <el-form-item label="Tiền cộng vào tài khoản shop" prop="debt">
              <el-input @focus="removeZero('debt')" @blur="addZero('debt')" v-model="localInvoice.debt" placeholder="Tiền cộng vào tài khoản shop">
                <template slot="append"><span class="text-red">{{localInvoice.debt | vnd}}</span></template>
              </el-input>
            </el-form-item>
            <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
          </el-col>
          <el-col :span="16">
            <h3 v-if="Object.keys(suggettionReceiver).length">Thông tin người nhận</h3>
            <p v-if="Object.keys(suggettionReceiver).length"><i class="fa fa-user"></i> {{suggettionReceiver.name}} &nbsp;&nbsp; <i class="fa fa-phone"></i> {{suggettionReceiver.phone}} &nbsp;&nbsp; <i class="fa fa-envelope-o"></i> {{suggettionReceiver.email}}</p>
            <el-table
              v-if="shipmentAdded.length"
              border
              :data="shipmentAdded"
              style="width: 100%">
              <el-table-column
                label="Mã"
                width="120">
                <template slot-scope="scope">
                  <p>
                    <el-tooltip placement="top" content="Mã đơn" class="display-inline">
                      <span class="shipment-code-display">{{ scope.row.id }}</span>
                    </el-tooltip>
                  </p>
                  <p>
                    <el-tooltip placement="top" content="Mã đơn HVC" class="display-inline">
                      <span class="shipment-code-display">{{ scope.row.code }}</span>
                    </el-tooltip>
                  </p>
                </template>
              </el-table-column>

              <el-table-column
                label="Người nhận">
                <template slot-scope="scope">
                  <p><i class="fa fa-user"></i>&nbsp;{{ scope.row.receiver.data.name }}</p>
                  <p><i class="fa fa-phone"></i>&nbsp;{{scope.row.receiver.data.phone}}</p>
                </template>
              </el-table-column>

              <el-table-column
                label="Người gửi">
                <template slot-scope="scope">
                  <p><i class="fa fa-user"></i>&nbsp;{{ scope.row.picker.data.name }}</p>
                  <p><i class="fa fa-phone"></i>&nbsp;{{scope.row.picker.data.phone}}</p>
                </template>
              </el-table-column>

              <el-table-column
                label="Phí COD">
                <template slot-scope="scope">
                  <span class="text-red">{{ scope.row.id | vnd}}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Người trả phí"
                width="110">
                <template slot-scope="scope">
                  <span >{{ scope.row.payer_txt }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label=""
                width="50"
                >
                <template slot-scope="scope">
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a class="text-red padding-all display-inline-block cursor-pointer" @click.prevent="removeShipment(scope.row)"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
  import { head, forEach } from 'lodash'
  import { editInvoice, getInvoice } from 'src/api/invoice'
  import invoiceMixin from './mixins'
  export default {
    name: 'NewInvoice',
    mixins: [invoiceMixin],
    methods: {
      validatorBeforeSubmit () {
        this.submitting = true
        this.$refs['edit-invoice-form'].validate((valid) => {
          if (valid) {
            this.changedData = false
            editInvoice(this.localInvoice.id, this.localInvoice).then(response => {
              switch (response.code) {
                case 200:
                  this.$store.dispatch('showNotify', {
                    title: 'Sửa thành công',
                    body: 'Sửa phiếu chi thành công',
                    type: 'success'
                  })
                  this.reloadGsTableAfterRedirect({name: 'invoice'}, 'invoices')
                  this.submitting = false
                  break
                case 422:
                  let er = response.data.errors
                  let message = head(er[Object.keys(er)[0]])
                  this.$store.dispatch('showNotify', {
                    title: 'Vui lòng kiểm tra thông tin cần nhập',
                    body: message,
                    type: 'warning'
                  })
                  this.submitting = false
                  break
                default:
                  this.$store.dispatch('showNotify', {
                    title: 'Sửa thất bại',
                    body: 'Sửa phiếu chi thất bại vui lòng kiểm tra lại thông tin',
                    type: 'danger'
                  })
                  this.submitting = false
              }
            })
          } else {
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            this.submitting = false
            return false
          }
        })
      }
    },
    mounted () {
      getInvoice(this.$route.params.id, {include: 'shipments,client,shipments.receiver,shipments.picker'}).then(response => {
        if (response.code === 200) {
          this.localInvoice.id = response.data.id
          this.localInvoice.total_amount = response.data.total_amount
          this.localInvoice.debt = response.data.debt
          this.localInvoice.description = response.data.description
          this.localInvoice.kind = response.data.kind.toString()
          this.localInvoice.client_id = response.data.client.data.id
          this.localInvoice.shipments = []
          forEach(response.data.shipments.data, shipment => {
            this.localInvoice.shipments.push(shipment.id)
          })
          this.shipmentAdded = response.data.shipments.data
          this.suggettionReceiver = response.data.client.data
          setTimeout(() => {
            this.watching = true
          }, 100)
        } else {
          this.$router.push({name: 'invoice'})
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Phiếu chi không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
        }
      })
    }
  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// EditInvoice.vue?80bb16f0